import React, { Component } from "react";

import {
  Modal, Banner,DropZone,Checkbox,BlockStack,Icon,Badge,Link, Text
} from "@shopify/polaris";
import { NoteMajor} from '@shopify/polaris-icons';
import { reqImportRedirects,reqGetImportRecords,reqGetFailedLog } from "../../api";

import { API_OSS } from '../../utils/constants';


// import utils from '../../utils/utils';

import Language from '../../i18n/Language';
import ImportRecordModel from "../ImportRecordModel";
import ImportRedirectFailureModel from "../ImportRedirectFailureModel";
const t = Language

class ImportRedirectActionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    //Import 窗口
    ImportActive: props.ImportActive,
    ImportActiveLoading: false,
    files:[],
    rejectedFiles:[],
    ImportRecordActive: false,
    FailedLogActive: false,

    //是否允许替换现有链接
    overwrite:false,

    //打开导入记录按钮状态
    OpenImportRecordLoading:false,
    isShowErrorTip: false,
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.ImportActive !== this.state.ImportActive) {
      let ImportActive = nextProps.ImportActive;
      this.setState({
        ImportActive: ImportActive,
      })
    }
    
    if(nextProps.userServices !== this.props.userServices){
      this.setState({
        userServices: nextProps.userServices
      })
    }
    return true
  }

  //关闭弹窗
  CloseImport =()=>{
    //重置上传框
    this.setState({
      files:[],
      rejectedFiles:[]
    })
    this.props.CloseImport()
  }

  //组件导入文件
  handleDrop = (_droppedFiles, acceptedFiles, rejectedFiles)=> {
    this.setState(
      {
        // files:[...this.state.files, ...acceptedFiles], //多文件
        files: [ ...acceptedFiles],  //单文件
        rejectedFiles:rejectedFiles
      },()=>{this.handleDropImage()}
    );
  }

  //图片数据加载
  handleDropImage = () => {
    var imageData = [];
    for(var i = 0; i < this.state.files.length;i++){
      const filesImg = this.state.files[i];
      // 开启FileReader
      var reader  = new FileReader();
      reader.readAsDataURL(filesImg); //读取文件保存在result中
      reader.onload = (e) =>  {
        var getRes = e.target.result;//读取的结果在result中
        imageData.push(
          {
            'name' : filesImg.name,
            'image' : getRes,
            'type' : filesImg.type,
          }
        );
      }
    }
    
    this.setState({
      imageData:imageData
    });
  }

  //是否要替换现有链接
  overwriteHandleCheckbox = () => {
    this.setState({
      overwrite: !this.state.overwrite
    });
  }

  // 导入提交
  handleImportAction = async () => {
    // console.log(this.props.userServices);return
    //等级等于0时弹窗
    if (!this.props.userServices.BrokenLinkImportExport) {
      this.props.openUpgradeModelShow()
      return "";
    }else{

      this.setState({ImportActiveLoading:true});
      //是否允许替换
      var overwriteRes = 0;
      if(this.state.overwrite === true){
        overwriteRes = 1;
      }

      const params = {
        files: this.state.imageData,
        overwriteRes:overwriteRes
      };
      const response = await reqImportRedirects(params);
  
      if (response.code === 200) {
        this.setState({
          files:[],
          rejectedFiles:[],
        });
        this.props.toggleToast(response.msg, false);
      } else {
        this.setState({
          isShowErrorTip: response.msg
        })
        // this.props.toggleToast(response.msg, true);
      }

      this.setState({ImportActiveLoading:false});
    }
    
  };

  //打开Import Record窗口
OpenImportRecord = async () => {

  this.setState({OpenImportRecordLoading:true});
  const response = await reqGetImportRecords();
  if (response.code === 200) {
    var importRecords = response.data;
    var recordRows = [];
    if(importRecords){
      importRecords.forEach((item, index) => {
        var status ='';
        switch (item.status) {
          case 0:
            status = <Badge>{t("Wait")}</Badge>;
            break;
          case 1:
            status = <Badge  status="success">{t("Finish")}</Badge>;
            break;
          case 2:
            status = <span className="Polaris-Badge Polaris-Badge--statusCritical">{t("Failed")}</span>;
            break;
          case 3:
            status = <Badge tone="info">{t("Processing")}</Badge>;
            break;
          default:
            break;
        }
        var failureRes = ""
        if(item.fail_count > 0){
          failureRes = <Link onClick={()=>this.OpenFailedLog(item.id)}>{t("View")}</Link>;
        }

        recordRows.push(
          [item.name,item.count,item.success_count+" / "+item.fail_count,status,item.create_at,failureRes]
        )
      })
    }
    this.CloseImport()
    this.setState({
      ImportRecordActive: true,
      imrecordRows:recordRows
    });
  }
  
  this.setState({OpenImportRecordLoading:false});

};

//打开导出日志错误信息
OpenFailedLog  = async (id) => {
  this.setState({OpenFailedLogLoading:true});
  const params = {
    import_sheet_id: id
  };
  const response = await reqGetFailedLog(params);

  if (response.code === 200) {
    var FailedLogData = response.data;
    var FailedLogRows = [];
    if(FailedLogData){
      FailedLogData.forEach((item, index) => {
        var status = "";
        switch (item.error_status) {
          case 0:
            status = <span className="Polaris-Badge Polaris-Badge--statusCritical">{t("Path existed")}</span>;
            break;
          case 1:
            status = <span className="Polaris-Badge Polaris-Badge--statusCritical">{t("Empty Link")}</span>;
            break;
          case 2:
            status = <span className="Polaris-Badge Polaris-Badge--statusCritical">{t("'/' can't be redirected")}</span>;
            break;
          case 3:
            status = <span className="Polaris-Badge Polaris-Badge--statusCritical">{t("Path excess limit")}</span>;
            break;
          case 4:
            status = <span className="Polaris-Badge Polaris-Badge--statusCritical">{t("Target link exists redirect")}</span>;
            break;
          case 5:
            status = <span className="Polaris-Badge Polaris-Badge--statusCritical">{t("Error")}</span>;
            break;
          case 6:
            status = <span className="Polaris-Badge Polaris-Badge--statusCritical">{t("Path and Target can't be same")}</span>;
            break;
          default:
            break;
        }

        FailedLogRows.push(
          [<div className="FailedLoTableMaxRow">{item.fr_link}</div>,<div className="FailedLoTableMaxRow">{item.to_link}</div>,status]
        )
      })
    }
    
    this.setState({
      ImportActive: false,
      ImportRecordActive: false,
      FailedLogActive:true,
      imFailedLogRows:FailedLogRows
    });
  }

  // this.setState({OpenImportRecordLoading:false});
}

//关闭Import Record窗口
CloseImportRecord = () => {
  this.setState({
    ImportRecordActive: false
  });
};

//关闭错误日志窗口
CloseFailedLog = () => {
  this.setState({
    FailedLogActive: false,
    ImportRecordActive: true
  });
};

    //点击联系客服
    handleContactService = ()=>{
      try {
        window.Willdesk.show()
      } catch(e) {
        this.props.toggleToast(t("Try again later"), true);
      }
    }


  render() {

    //系统判断显示下载模板
    var SystemDisplayTemplate = ""
    if(/macintosh|mac os x/i.test(navigator.userAgent) === true){
      SystemDisplayTemplate = <p>{t("Download a sample")}&nbsp;<a href={API_OSS+'/export/BrokenLink/template.xls?v=1'} download="template.xls">{t("XLS template")}</a> {t("to see an example of the format required.")}</p>
    }else{
      SystemDisplayTemplate = <p>{t("Download a sample")}&nbsp;<a href={API_OSS+'/export/BrokenLink/template.csv?v=1'} download="template.csv">{t("CSV template")}</a> / <a href={API_OSS+'/export/BrokenLink/template.xls?v=1'} download="template.xls">{t("XLS template")}</a> {t("to see an example of the format required.")}</p>
    }

    const hasError = this.state.rejectedFiles.length > 0;
    const errorMessage = hasError && (
      <div style={{ margin: '0.3rem 0 0.5rem' }}>
        <Banner
          title={t("Only csv and xls files can be uploaded.")}
          tone="critical"
          action={{
            content: t("Contact us"),
            onAction: this.handleContactService
          }}
          onDismiss={() => {
            this.setState({ rejectedFiles: [] })
          }}
        >
        </Banner>
        {/* <Banner
          title={t("The following file couldn't be uploaded:")}
          tone="critical"
        >
          <List type="bullet">
            {this.state.rejectedFiles.map((file, index) => (
              <List.Item key={index}>
                {`"${file.name}" is not supported. File type must be .csv, .xls`}
              </List.Item>
            ))}
          </List>
        </Banner> */}
      </div>
    );

    const uploadedFiles = this.state.files.length > 0 && (
      <BlockStack>
        {this.state.files.map((file, index) => (
          <BlockStack align="center" key={index}>
            <div><Icon source={NoteMajor} /></div>
            <div>
              {file.name} <Text variant="bodySm" as="p">{file.size} bytes</Text>
            </div>
          </BlockStack>
        ))}
      </BlockStack>
    );

    const fileUpload = !this.state.files.length && <DropZone.FileUpload actionTitle={t("Add file")} />;
    
    return (
      <div>
      <Modal
        open={this.state.ImportActive}
        onClose={this.CloseImport}
        title={t("Import Redirects")}
        secondaryActions={[
          {
            content: t("Import Records"),
            onAction: this.OpenImportRecord,
            loading: this.state.OpenImportRecordLoading
          },
          {
            content: t("Cancel"),
            onAction: this.CloseImport
          }
        ]}
        primaryAction={[
          {
            content: t("Import"),
            onAction: this.handleImportAction,
            loading: this.state.ImportActiveLoading
          }
        ]}
      >
        <Modal.Section>
          <BlockStack gap={200}>
            {
            this.state.isShowErrorTip && <Banner
              title={this.state.isShowErrorTip}
              tone="critical"
              onDismiss={() => {
                this.setState({
                  isShowErrorTip: '',
                })
              }}
              action={{
                content: t("Contact us"),
                onAction: this.handleContactService
              }}
            >
            </Banner>
          }
            {SystemDisplayTemplate}
            {errorMessage}
            <DropZone allowMultiple={false} accept=".csv,.xls" type="file" onDrop={this.handleDrop}>
              {uploadedFiles}
              {fileUpload}
            </DropZone>
            <Checkbox
              checked={this.state.overwrite}
              label={t("Overwrite existing data")}
              onChange={this.overwriteHandleCheckbox}
            />
          </BlockStack>
        </Modal.Section>
      </Modal>
      {/**导入记录 */}
      <ImportRecordModel ImportRecordActive={this.state.ImportRecordActive} imrecordRows={this.state.imrecordRows}  CloseImportRecord={this.CloseImportRecord}/>
      <ImportRedirectFailureModel FailedLogActive={this.state.FailedLogActive} CloseFailedLog={this.CloseFailedLog} imFailedLogRows={this.state.imFailedLogRows}/>
      </div>
    );
  }
}

export default ImportRedirectActionModal;